var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    fillOpacity: 0.3,
    d: "M1.707 13.707a.5.5 0 0 0 .708 0l6.353-6.353a.5.5 0 0 0 0-.708L2.415.293a.5.5 0 0 0-.708 0L.293 1.707a.5.5 0 0 0 0 .708l4.232 4.231a.5.5 0 0 1 0 .708L.293 11.585a.5.5 0 0 0 0 .708z"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHdpZHRoPSI5IiBoZWlnaHQ9IjE0Ij48cGF0aCBmaWxsPSIjMjgzRTRDIiBmaWxsLW9wYWNpdHk9Ii4zIiBkPSJNMS43MDcgMTMuNzA3YS41LjUgMCAwIDAgLjcwOCAwbDYuMzUzLTYuMzUzYS41LjUgMCAwIDAgMC0uNzA4TDIuNDE1LjI5M2EuNS41IDAgMCAwLS43MDggMEwuMjkzIDEuNzA3YS41LjUgMCAwIDAgMCAuNzA4bDQuMjMyIDQuMjMxYS41LjUgMCAwIDEgMCAuNzA4TC4yOTMgMTEuNTg1YS41LjUgMCAwIDAgMCAuNzA4bDEuNDE0IDEuNDE0WiIvPjwvc3ZnPg==";